import React from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { SignOutButton } from "../SignOutButton";
import "../desktop/deskKit.css";
import "./opsDesktop.css";

const ICONS = {
  clients: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  projects: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 7h18" />
      <path d="M5 7V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2" />
      <rect x="3" y="7" width="18" height="13" rx="2" />
    </svg>
  ),
  logs: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  timer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l3 2" />
      <path d="M9 2h6" />
    </svg>
  ),
};

function Chevron() {
  return (
    <svg className="ops-row__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

/** Desktop Command Center: one featured workspace plus the records/time launchers. Same actions as the phone cards. */
export function CommandCenterDesktop({
  showRecords,
  onOpenCreateClient,
  onOpenCreateProject,
  onOpenTimeLogs,
  onOpenTimeTracking,
  onSignOut,
}) {
  const rows = [
    { key: "logs", tone: "blue", icon: ICONS.logs, title: "Time Logs", desc: "Search, review, and manage employee time logs.", onClick: onOpenTimeLogs },
    ...(showRecords
      ? [
          { key: "clients", tone: "green", icon: ICONS.clients, title: "Create Client", desc: "Add and manage clients in the system.", onClick: onOpenCreateClient },
          { key: "projects", tone: "purple", icon: ICONS.projects, title: "Projects", desc: "Browse, create, and manage client projects.", onClick: onOpenCreateProject },
        ]
      : []),
  ];

  return (
    <CrewPilotModuleShell
      title="Time & Session"
      subtitle="Time & Session Control"
      layout={PAGE_LAYOUT.COMMAND}
      primary
      compact
      headerActions={onSignOut ? <SignOutButton onClick={onSignOut} /> : null}
    >
      <div className="ops-launch" data-testid="command-center-desktop">
        <button type="button" className="ops-feature ops-tone-green" onClick={onOpenTimeTracking} aria-label="Time Tracking: Launch">
          <span>
            <span className="ops-feature__icon">{ICONS.timer}</span>
            <h2>Time Tracking</h2>
            <p>Start, stop, and submit field time sessions.</p>
          </span>
          <span className="dt-btn dt-btn--primary ops-feature__cta">Launch</span>
        </button>
        <div className="ops-stack">
          {rows.map((row) => (
            <button key={row.key} type="button" className={`ops-row ops-tone-${row.tone}`} onClick={row.onClick}>
              <span className="ops-row__icon">{row.icon}</span>
              <span className="ops-row__text">
                <span className="ops-row__title">{row.title}</span>
                <span className="ops-row__desc">{row.desc}</span>
              </span>
              <Chevron />
            </button>
          ))}
        </div>
      </div>
    </CrewPilotModuleShell>
  );
}
